import axios from '../Backend';


export const getAllToForwardPhones = async () => {
        const res = await axios.get('/api/v2/forwardToPhones')
        const resData = res.data.data.data
        return resData
}
